export enum ProjectUserRole {
  ProjectCoordinator,
  LearningCoordinator,
  LearningSolutionsConsultant,
  Facilitator,
  Assessor,
  Moderator,
}
